import { FixaToast } from "../../wrappers/FixaToast/FixaToast";
import styles from "./simple-toast.module.css";

interface ToastProps {
  text: string | React.ReactElement;
  isOpen: boolean;
  onCloseRequest: () => void;
  ariaLabelCloseBtn?: string;
  actionButtonText?: string | React.ReactNode;
  actionClick?: () => void;
  className?: string;
  ariaLabel: string;
}

export const SimpleToast = ({
  text,
  isOpen,
  onCloseRequest,
  ariaLabelCloseBtn,
  actionButtonText,
  actionClick,
  "data-testid": testId,
  className,
  ariaLabel,
}: ToastProps & { "data-testid"?: string }) => {
  return (
    <FixaToast
      className={`${styles["simple-toast"]} ${className ? className : ""}`}
      text={text}
      isOpen={isOpen}
      onCloseRequest={onCloseRequest}
      ariaLabelCloseBtn={ariaLabelCloseBtn ?? ""}
      data-testid={testId} // Apply the testId conditionally
      actionButtonText={actionButtonText ?? ""}
      actionClick={actionClick ?? (() => {})} // Default to a no-op function
      ariaLabel={ariaLabel}
    />
  );
};
